import React from 'react';
import { Clock } from 'lucide-react';
export function TimelineSection() {
  const timeline = [{
    day: 'Día 1',
    desc: "El dolor punzante al despertar disminuye notablemente. El 'descenso de comando' ya funciona desde la primera vez."
  }, {
    day: 'Día 3',
    desc: 'Mayor facilidad para agacharte. Puedes ponerte los zapatos sin ayuda y sin contener la respiración.'
  }, {
    day: 'Día 7',
    desc: "Más confianza para caminar, conducir y sentarte. El miedo al 'latigazo sorpresa' empieza a retroceder."
  }, {
    day: 'Día 14+',
    desc: 'El protocolo se vuelve automático. Tu mañana empieza desde un lugar diferente — sin agonía como punto de partida.'
  }];
  return <section className="bg-slate-900 text-white py-24 px-4 border-t border-slate-800" data-id="element-275">
      <div className="max-w-4xl mx-auto" data-id="element-276">
        <div className="text-center mb-16" data-id="element-277">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/20 mb-6" data-id="element-278">
            <Clock className="w-8 h-8 text-blue-400" data-id="element-279" />
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-280">
            La Transformación
          </h2>
          <p className="text-xl text-slate-400" data-id="element-281">
            No promesas vacías. Una línea de tiempo honesta:
          </p>
        </div>

        <div className="relative" data-id="element-282">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-slate-800 -translate-x-1/2" data-id="element-283"></div>

          <div className="space-y-8 md:space-y-12" data-id="element-284">
            {timeline.map((item, idx) => <div key={idx} className={`relative flex flex-col md:flex-row items-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-285">
                {/* Center dot */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-orange-500 border-4 border-slate-900 items-center justify-center z-10" data-id="element-286"></div>

                <div className="w-full md:w-1/2 p-4 md:px-12" data-id="element-287">
                  <div className={`bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-xl ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right text-left'}`} data-id="element-288">
                    <span className="inline-block px-4 py-1 bg-orange-500/20 text-orange-400 font-bold rounded-full mb-4 text-sm uppercase tracking-wider" data-id="element-289">
                      {item.day}
                    </span>
                    <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-290">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}